import { create } from 'zustand';

interface NetworkStatusStore {
  isOffline: boolean;
  lastOnlineTime: number | null;
  setOffline: (offline: boolean) => void;
  markOnline: () => void;
  markOffline: () => void;
}

/**
 * Network status store for tracking connection state
 * Used to display ConnectionStatusBanner when offline
 */
export const useNetworkStatus = create<NetworkStatusStore>((set) => ({
  isOffline: false,
  lastOnlineTime: null,

  setOffline: (offline: boolean) =>
    set({
      isOffline: offline,
      lastOnlineTime: offline ? Date.now() : null,
    }),

  markOnline: () =>
    set({
      isOffline: false,
      lastOnlineTime: null,
    }),

  markOffline: () =>
    set({
      isOffline: true,
      lastOnlineTime: Date.now(),
    }),
}));
